import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import { desktopOnly, mobileOnly } from 'styles/mixins/displayMobileDesktop';
import type { LandingHeaderSqueezeProps } from '../';
import { darkBoldBackgroundStyles } from '../LandingHeaderSqueeze.style';

const altText =
  'Four Curology products — Gentle Cleanser, Cream Moisturizer, Everyday Sunscreen (spf 30) and Emergency Spot Patches —  against a beige background';

export const LANDING_HEADER_SQUEEZE_CONTENT: LandingHeaderSqueezeProps = {
  title: (
    <React.Fragment>
      See yourself <br />
      transform
    </React.Fragment>
  ),
  subtitle: 'Personalized skincare designed to help you get results',
  stats: [
    '93% report effective*',
    '5M+ treated',
    <React.Fragment key="reviews">
      9K+ 5-star reviews<sup>▵</sup>
    </React.Fragment>,
  ],
  images: (
    <React.Fragment>
      <StaticImage
        src="../images/squeezeMobileHero.png"
        alt={altText}
        css={[mobileOnly('block', 'smUp'), darkBoldBackgroundStyles]}
        loading="eager"
        objectFit="contain"
        objectPosition="center"
        width={412}
        placeholder="blurred"
      />
      <StaticImage
        src="../images/squeezeDesktopHero.png"
        alt={altText}
        css={[desktopOnly('block', 'smUp')]}
        loading="eager"
        objectFit="contain"
        objectPosition="bottom"
        placeholder="blurred"
      />
    </React.Fragment>
  ),
};
